<script>
// import PageEditor from './PageEditor/PageEditor';

export default {
  props: ['item'],
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<template>
  <div>

    <div class="row">
      <div class="col-sm-6">
        <w-field SimpleDataType="String" v-model="item.title" Title="Title :" Required></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String" v-model="item.sub_title" Title="Sub title :"></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="Money" v-model="item.price" Title="Price :" Required></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String" v-model="item.sub_price" Title="Sub price :"></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String" v-model="item.ribbon_text" Title="Ribbon text :"></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String List, Single" Title="Ribbon color :" :Options="theme_colors" v-model="item.ribbon_color"></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String List, Single" v-model="item.status" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]" Title="Live :" Required></w-field>
      </div>

      <div class="col-sm-12">
        <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line" /> Upcharges by zip code</h5>
        <div v-for="(zip, zip_i) in item.upcharges" :key="'z'+zip_i" class="input-group mb-1">
          <input type="number" min="9999" max="100000" class="form-control" placeholder="Zip code..." v-model="zip.zip_code" required>
          <div class="input-group-append">
            <w-money class="form-control" v-model="zip.upcharge" placeholder="Upcharge..."  required></w-money>
            <button class="btn btn-white" type="button" v-tippy content="Delete" @click="item.upcharges.splice(zip_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
          </div>
        </div>
        <div class="mb-2">
          <button class="btn btn-sm btn-primary" type="button" @click="item.upcharges.push({zip_code:'',upcharge:0,active:1})"><Icon icon="ri:add-line" height="18"></Icon> Add upcharge</button>
        </div>
      </div>

      <div class="col-sm-12">
        <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line" /> Upcharges by listings</h5>
        <p class="text-muted small mb-3">Upcharges by listings can be used to upcharge a package based off of how many existing listings not in the "Trash" stage a visitor has. For example if you wanted to upcharge anyone who already has at least 1 existing listing you would enter something like: || Listings greater than || 0 || $299 || below.</p>
        <div v-for="(upcharge, upcharge_i) in item.upcharges_listings" :key="'u'+upcharge_i" class="input-group mb-1">
          <select class="form-control" v-model="upcharge.condition" required>
            <option value="greater_than">Listings greater than</option>
            <option value="less_than">Listings less than</option>
          </select>
          <w-field SimpleDataType="Number" v-model="upcharge.value" required></w-field>
          <div class="input-group-append">
            <w-money class="form-control" v-model="upcharge.upcharge" placeholder="Upcharge..."  required></w-money>
            <button class="btn btn-white" type="button" v-tippy content="Delete" @click="item.upcharges_listings.splice(upcharge_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
          </div>
        </div>
        <div class="mb-2">
          <button class="btn btn-sm btn-primary" type="button" @click="item.upcharges_listings.push({condition:'greater_than',value:0,upcharge:0,active:1})"><Icon icon="ri:add-line" height="18"></Icon> Add upcharge</button>
        </div>
      </div>
    </div>

  </div>
</template>
